// extracted by mini-css-extract-plugin
export default {"subtitle":"publications_subtitle__obtlQ","link":"publications_link__Ps76u","fade-in":"publications_fade-in__COUKi"};